<script>
import Axios from 'axios'
import Summernote from './utility/summernote'
import Users from './settings/Users'
import MyAccount from './settings/MyAccount'
import BusinessProfile from './settings/BusinessProfile'
import Integrations from './settings/Integrations'
import Groups from './settings/Groups'
import Billing from './settings/Billing'
import Sms from './settings/Sms'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import Production from '@/components/settings/Production.vue'
import EstimatesBooking from './settings/estimates-booking/EstimatesBooking.vue'
import autoCopilot from './settings/auto_copilot/auto-copilot.vue'
import { uuid } from 'vue-uuid'
import TheInvoices from '@/components/settings/TheInvoices'
import TheEstimates from '@/components/settings/TheEstimates'
import TheCards from '@/components/settings/TheCards'

export default {
  name: 'settings',
  data () {
    return {
      isAddLocationPressed: 0,
      isSettingsAlreadyLoaded: false,
      filter: '',
      tab: '',
      typingTimer: {},
      typingTimerCEStatusId: null,
      settings: {
        isCopilotEnabled: false,
      },
      rawSettings: {},
      switch: { size: 'small', color: '#3E70C9' },
      nameAddStatus: '',
      fields: [
        {
          label: 'Username',
          key: 'username',
          sortable: true,
          tdClass: 'text-center clickable number',
          thClass: 'text-center bg-navyblue number'
        },
        {
          label: 'Name',
          key: 'full_name',
          sortable: true,
          tdClass: 'text-center clickable card-number',
          thClass: 'text-center bg-navyblue card-number'
        },
        {
          label: 'Email',
          key: 'email',
          sortable: true,
          tdClass: 'text-center clickable number',
          thClass: 'text-center bg-navyblue number'
        },
        {
          label: 'Location',
          key: 'address',
          sortable: true,
          tdClass: 'clickable customer',
          thClass: 'bg-navyblue customer'
        },
        {
          label: 'Work Phone',
          key: 'work_phone',
          sortable: true,
          tdClass: 'text-center clickable rego',
          thClass: 'text-center bg-navyblue rego'
        },
        {
          label: 'Mobile Phone',
          key: 'mobile_phone',
          sortable: true,
          tdClass: 'text-center clickable make',
          thClass: 'text-center bg-navyblue make'
        },
        {
          label: 'Email',
          key: 'email',
          sortable: true,
          tdClass: 'text-center clickable model',
          thClass: 'text-center bg-navyblue model'
        },
        {
          label: 'Role',
          key: 'role',
          sortable: true,
          tdClass: 'text-center clickable colour',
          thClass: 'text-center bg-navyblue colour'
        },
        {
          label: 'Actions',
          key: 'actions',
          sortable: true,
          tdClass: 'text-center clickable insurance',
          thClass: 'text-center bg-navyblue insurance'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      isTechnicalUser: 'isTechnicalUser',
      isCustomerUser: 'isCustomerUser',
      isEstimatorUser: 'isEstimatorUser',
      isPDRTechnicianUser: 'isPDRTechnicianUser',
      isShopManagerUser: 'isShopManagerUser',
      isProductionManagerUser: 'isProductionManagerUser',
      isStatusActive: 'isStatusActive',
      getterBusinessName: 'getBusinessName',
      isShowBusinessName: 'isShowBusinessName',
      isRsEnabled: 'isRsEnabled',
    }),
    isCopilotEnabled () {
      return !!(this.settings?.isCopilotEnabled === true)
    },
    isActiveParssearchCode () {
      return !!(
          this.settings &&
          this.settings.partssearch &&
          this.settings.partssearch.api_key &&
          this.settings.partssearch.enabled
      )
    },
    isSetDefaultPSLoc () {
      return !!(
          this.settings &&
          this.settings.partssearch &&
          this.settings.partssearch.partssearchDefaultLocation
      )
    },
    defaultPSLocId () {
      return this.settings?.partssearch?.partssearchDefaultLocation
    }
  },
  methods: {
    routeCalculation () {
      if (this.isEstimatorUser) {
        let params = { name: 'settings', params: { tab: 'my-account' } }
        this.$router.push(params).catch(() => {})
      } else if (this.$route.params.customTab) {
        if (this.$route.params.customSubTab !== '') {
          if (this.$route.params.customTab === 'business-profile') {
            let params = {
              name: 'business',
              params: { tab: this.$route.params.customSubTab }
            }
            this.$router.push(params).catch(() => {})
            this.$storage.set(
                'views.advancedSettings.defaultView',
                'business-profile'
            )
          }
        } else {
          this.$storage.set(
              'views.advancedSettings.defaultView',
              this.$route.params.customTab
          )
          let params = {
            name: 'settings',
            params: { tab: this.$route.params.customTab }
          }
          this.$router.push(params).catch(() => {})
        }
      } else if (
          !_.isEmpty(this.$storage.get('views.advancedSettings.defaultView'))
      ) {
        let currentTab = ''
        currentTab = this.$storage.get('views.advancedSettings.defaultView')
        let resultPath = '/settings/' + currentTab
        if (this.$route.path !== resultPath) {
          if (currentTab === 'integrations') {
            let subTab = 'partssearch'
            if (
                !_.isEmpty(
                    this.$storage.get(
                        'views.advancedSettings.integrations.defaultView'
                    )
                )
            ) {
              subTab = this.$storage.get(
                  'views.advancedSettings.integrations.defaultView'
              )
            }
            let params = { name: 'integrations', params: { tab: subTab } }
            this.$router.push(params).catch(() => {})
          } else if (currentTab === 'business-profile') {
            let subTab = 'details'
            if (
                !_.isEmpty(
                    this.$storage.get('views.advancedSettings.business.defaultView')
                )
            ) {
              subTab = this.$storage.get(
                  'views.advancedSettings.business.defaultView'
              )
            }
            let params = { name: 'business', params: { tab: subTab } }
            this.$router.push(params).catch(() => {})
          } else if (currentTab === 'billing') {
            let subTab = 'settings'
            if (
                !_.isEmpty(
                    this.$storage.get('views.advancedSettings.billing.defaultView')
                )
            ) {
              subTab = this.$storage.get(
                  'views.advancedSettings.billing.defaultView'
              )
            }
            let params = { name: 'billing', params: { tab: subTab } }
            this.$router.push(params).catch(() => {})
          } else {
            this.$router
                .push({ name: 'settings', params: { tab: currentTab } })
                .catch(() => {})
          }
        }
      } else {
        let path = this.$route.path.split('/')
        let tab = path[path.length - 1]
        if (path[path.length - 2] === 'integrations') {
          let params = {
            name: 'integrations',
            params: { tab: path[path.length - 1] }
          }
          this.$router.push(params).catch(() => {})
        } else if (path[path.length - 2] === 'business-profile') {
          let params = {
            name: 'business',
            params: { tab: path[path.length - 1] }
          }
          this.$router.push(params).catch(() => {})
        } else if (path[path.length - 2] === 'billing') {
          let params = {
            name: 'billing',
            params: { tab: path[path.length - 1] }
          }
          this.$router.push(params).catch(() => {})
        } else if (
            tab === 'integrations' ||
            tab === 'files' ||
            tab === 'estimates' ||
            tab === 'invoices' ||
            tab === 'users' ||
            tab === 'groups' ||
            tab === 'my-account' ||
            tab === 'business-profile' ||
            tab === 'billing' ||
            tab === 'sms'
        ) {
          if (tab === 'integrations') {
            let subTab = 'partssearch'
            if (
                !_.isEmpty(
                    this.$storage.get(
                        'views.advancedSettings.integrations.defaultView'
                    )
                )
            ) {
              subTab = this.$storage.get(
                  'views.advancedSettings.integrations.defaultView'
              )
            }
            let params = { name: 'integrations', params: { tab: subTab } }
            this.$router.push(params).catch(() => {})
          } else if (tab === 'business-profile') {
            let subTab = 'details'
            if (
                !_.isEmpty(
                    this.$storage.get('views.advancedSettings.business.defaultView')
                )
            ) {
              subTab = this.$storage.get(
                  'views.advancedSettings.business.defaultView'
              )
            }
            let params = { name: 'business', params: { tab: subTab } }
            this.$router.push(params).catch(() => {})
          } else if (tab === 'billing') {
            let subTab = 'settings'
            if (
                !_.isEmpty(
                    this.$storage.get('views.advancedSettings.billing.defaultView')
                )
            ) {
              subTab = this.$storage.get(
                  'views.advancedSettings.billing.defaultView'
              )
            }
            let params = { name: 'billing', params: { tab: subTab } }
            this.$router.push(params).catch(() => {})
          } else {
            this.$router
                .push({ name: 'settings', params: { tab: tab } })
                .catch(() => {})
          }
        } else {
          let params = { name: 'integrations', params: { tab: 'partssearch' } }
          this.$router.push(params).catch(() => {})
        }
      }

      this.setUrl()
    },
    onTabChange () {
      $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
        this.tab = $(e.target).attr('href')
        let route = '',
            params = ''
        if (this.tab === '/settings/users') {
          route = 'users'
          this.$storage.set('views.advancedSettings.defaultView', 'users')
        } else if (this.tab === '/settings/business-profile') {
          route = 'business-profile'
          this.$storage.set(
              'views.advancedSettings.defaultView',
              'business-profile'
          )
        } else if (this.tab === '/settings/production') {
          route = 'production'
          this.$storage.set('views.advancedSettings.defaultView', 'production')
        } else if (this.tab === '/settings/integrations') {
          route = 'integrations'
          this.$storage.set(
              'views.advancedSettings.defaultView',
              'integrations'
          )
        } else if (this.tab === '/settings/groups') {
          route = 'groups'
          this.$storage.set('views.advancedSettings.defaultView', 'groups')
        } else if (this.tab === '/settings/auto-copilot') {
          route = 'auto-copilot'
          this.$storage.set('views.advancedSettings.defaultView', 'auto-copilot')
        } else if (this.tab === '/settings/my-account') {
          route = 'my-account'
          this.$storage.set('views.advancedSettings.defaultView', 'my-account')
        } else if (this.tab === '/settings/methodology') {
          route = 'methodology'
          this.$storage.set('views.advancedSettings.defaultView', 'methodology')
        } else if (this.tab === '/settings/estimates') {
          route = 'estimates'
          this.$storage.set('views.advancedSettings.defaultView', 'estimates')
        } else if (this.tab === '/settings/estimates-booking') {
          route = 'estimates-booking'
          this.$storage.set(
              'views.advancedSettings.defaultView',
              'estimates-booking'
          )
        } else if (this.tab === '/settings/files') {
          route = 'files'
          this.$storage.set('views.advancedSettings.defaultView', 'files')
        } else if (this.tab === '/settings/invoices') {
          route = 'invoices'
          this.$storage.set('views.advancedSettings.defaultView', 'invoices')
        } else if (this.tab === '/settings/billing') {
          route = 'billing'
          this.$storage.set('views.advancedSettings.defaultView', 'billing')
        } else if (this.tab === '/settings/sms') {
          route = 'sms'
          this.$storage.set('views.advancedSettings.defaultView', 'sms')
        }
        if (route === 'integrations') {
          let subTab = 'partssearch'
          if (
              !_.isEmpty(
                  this.$storage.get(
                      'views.advancedSettings.integrations.defaultView'
                  )
              )
          ) {
            subTab = this.$storage.get(
                'views.advancedSettings.integrations.defaultView'
            )
          }
          let params = { name: 'integrations', params: { tab: subTab } }
          this.$router.replace(params).catch(() => {})
        } else if (route === 'billing') {
          let subTab = 'settings'
          if (
              !_.isEmpty(
                  this.$storage.get('views.advancedSettings.billing.defaultView')
              )
          ) {
            subTab = this.$storage.get(
                'views.advancedSettings.billing.defaultView'
            )
          }
          let params = { name: 'billing', params: { tab: subTab } }
          this.$router.replace(params).catch(() => {})
        } else if (route === 'business-profile') {
          let subTab = 'details'
          if (
              !_.isEmpty(
                  this.$storage.get('views.advancedSettings.business.defaultView')
              )
          ) {
            subTab = this.$storage.get(
                'views.advancedSettings.business.defaultView'
            )
          }
          let params = { name: 'business', params: { tab: subTab } }
          this.$router.replace(params).catch(() => {})
        } else {
          params = route
              ? { name: 'settings', params: { tab: route } }
              : '/settings'
          this.$router.replace(params).catch(() => {})
        }
      })
    },
    onClickAddLocation: function () {
      this.isAddLocationPressed++
    },
    addNewUser () {
      this.$refs.users.onClickAddNewUser()
    },
    isTabActive: function (tab) {
      let url = this.$route.path
      //console.log('this.tab', this.tab);
      //console.log('tab', tab);
      //console.log('url', url);
      if (
          this.tab === '/settings/integrations' &&
          tab === 'integrations' &&
          url.includes('/settings/integrations')
      ) {
        return true
      } else if (
          this.tab === '/settings/production' &&
          tab === 'production' &&
          url === '/settings/production'
      ) {
        return true
      } else if (
          this.tab === '/settings/users' &&
          tab === 'users' &&
          url === '/settings/users'
      ) {
        return true
      } else if (
          this.tab === '/settings/groups' &&
          tab === 'groups' &&
          url === '/settings/groups'
      ) {
        return true
      } else if (
          this.tab === '/settings/auto-copilot' &&
          tab === 'auto-copilot' &&
          url === '/settings/auto-copilot'
      ) {
        return true
      } else if (
          this.tab === '/settings/business-profile' &&
          url.includes('/settings/business-profile') &&
          tab === 'business-profile'
      ) {
        return true
      } else if (
          this.tab === '/settings/my-account' &&
          url === '/settings/my-account' &&
          tab === 'my-account'
      ) {
        return true
      } else if (
          this.tab === '/settings/methodology' &&
          url === '/settings/methodology' &&
          tab === 'methodology'
      ) {
        return true
      } else if (
          this.tab === '/settings/estimates' &&
          url === '/settings/estimates' &&
          tab === 'estimates'
      ) {
        return true
      } else if (
          this.tab === '/settings/estimates-booking' &&
          url === '/settings/estimates-booking' &&
          tab === 'estimates-booking'
      ) {
        return true
      } else if (
          this.tab === '/settings/files' &&
          url === '/settings/files' &&
          tab === 'files'
      ) {
        return true
      } else if (
          this.tab === '/settings/invoices' &&
          url === '/settings/invoices' &&
          tab === 'invoices'
      ) {
        return true
      } else if (
          this.tab === '/settings/billing' &&
          url.includes('/settings/billing') &&
          tab === 'billing'
      ) {
        return true
      } else if (
          this.tab === '/settings/sms' &&
          url === '/settings/sms' &&
          tab === 'sms'
      ) {
        return true
      }
      return false
    },
    findObjectInSettingsForSave (tab, settings) {
      let data = {}
      switch (tab) {
        case '/settings/auto-copilot':
          data = {
            copilot: { ...settings.copilot },
          }
          break
        case '/settings/integrations':
          if (this.$route.path.includes('/settings/integrations/webtrim')) {
            this.$refs.integrations.saveWebtrim()
          }
          if (this.$route.path.includes('/settings/integrations/xero')) {
            this.$refs.integrations.saveXeroAuthData()
            return null
          }
           if (this.$route.path.includes('/settings/integrations/orm')) {
            this.$refs.integrations.saveIagAuthData()
          }
          if (this.$route.path.includes('/settings/integrations/partssearch')) {
            data = { partssearch: { ...settings.partssearch } }
          }
          if (this.$route.path.includes('/settings/integrations/claimlinq')) {
            data = { claimlinq: { ...settings.claimlinq } }
          }
          if (this.$route.path.includes('/settings/integrations/estimage')) {
            data = { estimage: { ...settings.estimage } }
          }

          break
        case '/settings/estimates-booking':
          data = {
            estimatesBooking: { ...settings.estimatesBooking }
          }
          break
        case '/settings/estimates':
          data = {
            estimates: { ...settings.estimates },
            rates: { ...settings.rates }
          }
          break
        case '/settings/invoices':
          data = {
            invoices: { ...settings.invoices }
          }
          break
        case '/settings/files':
          if (this.$refs['cardsTab']) {
            this.$refs['cardsTab'].saveData()
          }
          data = {
            cards: { ...settings.cards }
          }
          break
        case '/settings/invoices':
          data = {
            invoices: { ...settings.invoices }
          }
          break
        case '/settings/production':
          data = {
            production: { ...settings.production }
          }
          if (data?.production?.days) {
            _.forIn(data.production.days, (itm, ind) => {
              if (_.toString(itm)) {
                data.production.days[ind] = itm == 'true' ? true : false
              }
            })
          }

          if (!_.isEmpty(data?.production?.definitions?.categories)) {
            _.forEach(data.production.definitions.categories, (itm, ind) => {
              if (!itm.id) {
                itm.id = uuid.v1()
              }
            })
          }
          break
        case '/settings/groups':
          if (this.$refs['groups']) {
            this.$refs['groups'].changedActiveStatus()
          }
          data = null
          break
        case '/settings/sms':
          data = {
            sms: { ...settings.sms },
            maxSmsTextLength: settings.maxSmsTextLength
          }
          break
        case '/settings/billing':
          data = {
            billing: { ...settings.billing }
          }
          break
        case '/settings/business-profile':
          this.$refs['businessProfile'].saveBusinessProfile()
          data = null
          break
      }
      return data
    },
    updateSettings (tab, settings) {
      if (!this.isSettingsAlreadyLoaded) {
        return
      }
      const data = this.findObjectInSettingsForSave(tab, settings)
      if (!data) return
      Axios.post('/fe/settings/vendor', data)
          .then((response) => {
            NProgress.done()
            toastr.success(response.data.msg)
            if (this.isTabActive('files')) {
              this.$store.dispatch('loadCEStatuses')
            }
          })
          .catch((error) => {
            NProgress.done()
            toastr.error(error)
          })
          .finally(() => {
            if (
                this.tab === '/settings/integrations' &&
                this.$route.params.tab === 'partssearch'
            ) {
              this.$store.dispatch('loadPartsSearchLocation')
            }
          })
    },
    // updateSettings: function () {
    //   console.log("updateSettings", this.tab);
    //   return;
    //   if (
    //     this.tab === "#integrations" &&
    //     this.$route.path.includes("/settings/integrations/webtrim")
    //   ) {
    //     this.$refs.integrations.saveWebtrim();
    //     return;
    //   }

    //   let data = _.cloneDeep(this.settings);

    //   if (data?.production?.days) {
    //     _.forIn(data.production.days, (itm, ind) => {
    //       if (_.toString(itm)) {
    //         data.production.days[ind] = itm == "true" ? true : false;
    //       }
    //     });
    //   }

    //   if (!_.isEmpty(data?.production?.definitions?.categories)) {
    //     _.forEach(data.production.definitions.categories, (itm, ind) => {
    //       if (!itm.id) {
    //         itm.id = uuid.v1();
    //       }
    //     });
    //   }

    //   /*NProgress.start()*/
    //   Axios.post("/fe/settings/vendor", data)
    //     .then((response) => {
    //       NProgress.done();
    //       toastr.success(response.data.msg);
    //       if (this.isTabActive("files")) {
    //         this.$store.dispatch("loadCEStatuses");
    //       }
    //     })
    //     .catch((error) => {
    //       NProgress.done();
    //       toastr.error(error);
    //     })
    //     .finally(() => {
    //       if (
    //         this.tab === "#integrations" &&
    //         this.$route.params.tab === "partssearch"
    //       ) {
    //         this.$store.dispatch("loadPartsSearchLocation");
    //       }
    //     });

    //   if (this.isTabActive("files") && this.$refs["cardsTab"]) {
    //     this.$refs["cardsTab"].saveData();
    //   }
    // },
    setUrl () {
      let url = this.$route.path

      if (url.includes('/settings/integrations')) {
        this.tab = '/settings/integrations'
      } else if (url === '/settings/production') {
        this.tab = '/settings/production'
      } else if (url === '/settings/users') {
        this.tab = '/settings/users'
      } else if (url === '/settings/groups') {
        this.tab = '/settings/groups'
      } else if (url === '/settings/auto-copilot') {
        this.tab = '/settings/auto-copilot'
      } else if (url.includes('/settings/business-profile')) {
        this.tab = '/settings/business-profile'
      } else if (url === '/settings/my-account') {
        this.tab = '/settings/my-account'
      } else if (url === '/settings/methodology') {
        this.tab = '/settings/methodology'
      } else if (url === '/settings/estimates') {
        this.tab = '/settings/estimates'
      } else if (url === '/settings/estimates-booking') {
        this.tab = '/settings/estimates-booking'
      } else if (url === '/settings/files') {
        this.tab = '/settings/files'
      } else if (url === '/settings/invoices') {
        this.tab = '/settings/invoices'
      } else if (url.includes('/settings/billing')) {
        this.tab = '/settings/billing'
      } else if (url === '/settings/billing') {
        this.tab = '/settings/billing'
      } else if (url === '/settings/sms') {
        this.tab = '/settings/sms'
      }
    },
    loadVendorSettings (toastrText = false) {
      this.isSettingsAlreadyLoaded = false
      NProgress.start()
      Promise.all([
        Axios.get('/fe/settings/vendor'),
        Axios.get('/fe/settings/vendor-statuses')
      ])
          .then(([vendorResponse, statusesResponse]) => {
            if (vendorResponse.data) {
              this.$store.dispatch('loadVendorInfo')
              this.settings = vendorResponse.data
              const defaultAutoTopUp = {
                daDollarsStandard: false,
                daNtarltarStandard: false,
                viVehicleIdentification: false,
                piPartIdentification: false,
              };
              //temporary solution until there is a backend
              if (!this.settings.billing?.credits) {
                this.$set(this.settings.billing, 'credits', {});
                 this.$set(this.settings.billing.credits, 'autoTopUp', {
                ...defaultAutoTopUp
              });
              }

              if (!this.settings.estimates.ii) {
                this.settings.estimates.ii = {
                  show_tax_number: false,
                  show_col_headings: false,
                  show_item_code: false,
                  show_unit_price_qty: false,
                  show_payment_advice: false,
                  show_address: false,
                  show_tax_column: false,
                  show_logo: false,
                  hide_discount: false,
                  show_contact_number: false,
                  show_payment_service: false
                }
              }

              if (!this.settings.invoices.ii) {
                this.settings.invoices.ii = {
                  show_tax_number: false,
                  show_col_headings: false,
                  show_item_code: false,
                  show_unit_price_qty: false,
                  show_payment_advice: false,
                  show_address: false,
                  show_tax_column: false,
                  show_logo: false,
                  hide_discount: false,
                  show_contact_number: false,
                  show_payment_service: false,
                  advice: ''
                }
              }

              if (this.settings?.production?.days) {
                _.forIn(this.settings.production.days, (itm, ind) => {
                  if (_.isBoolean(itm)) {
                    this.settings.production.days[ind] = _.toString(itm)
                  }
                })
              }

              if (statusesResponse.data && statusesResponse.data._status) {
                this.$set(this.settings, 'phases', statusesResponse.data.phases || []);
              }

              if (toastrText) {
                toastr.success(
                    'Your change to play type ' +
                    toastrText +
                    ' has been successful'
                )
              }
              this.rawSettings = _.cloneDeep(this.settings)
            }
          })
          .catch((error) => {
            toastr.error(error)
          })
          .finally(() => {
            if (this.tab != '/settings/files') {
              NProgress.done()
            }
            this.isSettingsAlreadyLoaded = true
          })
    }
  },
  mounted: function () {
    console.log('Settings!!! Mounted')
    let routePath = _.cloneDeep(this.$route.path)

    this.routeCalculation()

    if (this.isShopManagerUser) {
      this.loadVendorSettings()
    }
  },
  watch: {
    isShopManagerUser (newVal) {
      if (newVal && !this.isSettingsAlreadyLoaded) {
        this.loadVendorSettings()
      }
    },
    $route (newVal, oldVal) {
      if (newVal?.name && oldVal?.name && newVal?.name == 'myAccount' && oldVal?.name != 'myAccount') {
        this.routeCalculation()
      }
      if (newVal?.name && oldVal?.name && newVal?.name == 'business' && oldVal?.name != 'business') {
        this.routeCalculation()
      }
    },
    settings: {
      deep: true,
      handler (newVal) {
        if (!_.isEqual(newVal, this.rawSettings)) {
        } else {
        }
      }
    }
  },
  components: {
    Production,
    EstimatesBooking,
    autoCopilot,
    Summernote,
    Users,
    MyAccount,
    BusinessProfile,
    Integrations,
    Groups,
    Billing,
    Sms,
    TheInvoices,
    TheEstimates,
    TheCards
  }
}
</script>

<template>
  <div>
    <div class="page-header">
      <h4>Advanced Settings</h4>
      <ol class="breadcrumbs">
        <li class="breadcrumb-item home">
          <router-link to="/">Home</router-link>
        </li>
        <li class="breadcrumb-item active">Advanced Settings</li>
      </ol>
      <h4 v-if="isShowBusinessName" class="header-display-name">{{ getterBusinessName }}</h4>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="box box-block bg-white">
          <div>
            <div>
              <div class="setting-card">
                <div class="tabs-component">
                  <ul
                      style="max-width: calc(100% - 162px)"
                      class="tab-header nav nav-tabs nav-tabs-2 float-sm-left btn-right-padding"
                  >
                    <template v-if="isShopManagerUser">
                      <li class="tabs-component-tab nav-item">
                        <a
                            class="tabs-component-tab-a nav-link"
                            v-bind:class="{ active: isTabActive('files') }"
                            data-toggle="tab"
                            @click="onTabChange"
                            href="/settings/files"
                        >Files</a
                        >
                      </li>
                      <li class="tabs-component-tab nav-item">
                        <a
                            class="tabs-component-tab-a nav-link"
                            v-bind:class="{ active: isTabActive('estimates') }"
                            data-toggle="tab"
                            @click.prevent="onTabChange"
                            href="/settings/estimates"
                        >Estimates</a
                        >
                      </li>
                      <li class="tabs-component-tab nav-item">
                        <a
                            class="tabs-component-tab-a nav-link"
                            v-bind:class="{
                            active: isTabActive('estimates-booking')
                          }"
                            data-toggle="tab"
                            @click.prevent="onTabChange"
                            href="/settings/estimates-booking"
                        >Estimates Booking</a
                        >
                      </li>
                      <li class="tabs-component-tab nav-item">
                        <a
                            class="tabs-component-tab-a nav-link"
                            v-bind:class="{ active: isTabActive('invoices') }"
                            data-toggle="tab"
                            @click.prevent="onTabChange"
                            href="/settings/invoices"
                        >Invoices</a
                        >
                      </li>
                      <li
                          class="tabs-component-tab nav-item"
                          v-if="
                          isShopManagerUser ||
                          isCustomerUser ||
                          isProductionManagerUser
                        "
                      >
                        <a
                            class="tabs-component-tab-a nav-link"
                            v-bind:class="{ active: isTabActive('production') }"
                            data-toggle="tab"
                            @click="onTabChange"
                            href="/settings/production"
                        >Production</a
                        >
                      </li>
                      <li
                          class="tabs-component-tab nav-item"
                          v-if="
                          isCopilotEnabled &&
                          (isShopManagerUser ||
                          isCustomerUser ||
                          isProductionManagerUser)
                        "
                      >
                        <a
                            class="tabs-component-tab-a nav-link"
                            v-bind:class="{ active: isTabActive('auto-copilot') }"
                            data-toggle="tab"
                            @click="onTabChange"
                            href="/settings/auto-copilot"
                        >Auto-CoPilot</a
                        >
                      </li>
                      <li class="tabs-component-tab nav-item">
                        <a
                            class="tabs-component-tab-a nav-link"
                            v-bind:class="{ active: isTabActive('users') }"
                            data-toggle="tab"
                            @click.prevent="onTabChange"
                            href="/settings/users"
                        >Users</a
                        >
                      </li>
                      <li class="tabs-component-tab nav-item">
                        <a
                            class="tabs-component-tab-a nav-link"
                            v-bind:class="{ active: isTabActive('groups') }"
                            data-toggle="tab"
                            @click.prevent="onTabChange"
                            href="/settings/groups"
                        >Groups</a
                        >
                      </li>
                      <li class="tabs-component-tab nav-item">
                        <a
                            class="tabs-component-tab-a nav-link"
                            v-bind:class="{ active: isTabActive('integrations') }"
                            @click="onTabChange"
                            data-toggle="tab"
                            href="/settings/integrations"
                        >Integrations</a
                        >
                      </li>
                    </template>
                    <li
                        class="tabs-component-tab nav-item"
                        v-if="
                        isShopManagerUser ||
                        isCustomerUser ||
                        isProductionManagerUser
                      "
                    >
                      <a
                          class="tabs-component-tab-a nav-link"
                          v-bind:class="{ active: isTabActive('sms') }"
                          data-toggle="tab"
                          @click="onTabChange"
                          href="/settings/sms"
                      >SMS</a
                      >
                    </li>
                    <li class="tabs-component-tab nav-item">
                      <a
                          class="tabs-component-tab-a nav-link"
                          v-bind:class="{ active: isTabActive('my-account') }"
                          data-toggle="tab"
                          @click.prevent="onTabChange"
                          href="/settings/my-account"
                      >My Account</a
                      >
                    </li>
                    <template v-if="isShopManagerUser">
                      <li class="tabs-component-tab nav-item">
                        <a
                            class="tabs-component-tab-a nav-link"
                            v-bind:class="{
                            active: isTabActive('business-profile')
                          }"
                            @click.prevent="onTabChange"
                            data-toggle="tab"
                            href="/settings/business-profile"
                        >Business Profile</a
                        >
                      </li>
                    </template>
                    <template v-if="isShopManagerUser">
                      <li class="tabs-component-tab nav-item">
                        <a
                            class="tabs-component-tab-a nav-link"
                            v-bind:class="{ active: isTabActive('billing') }"
                            @click.prevent="onTabChange"
                            data-toggle="tab"
                            href="/settings/billing"
                        >Billing</a
                        >
                      </li>
                    </template>

                  </ul>
                  <div class="tab-header rs-btn-group float-sm-right mt-1-sm">
                    <div class="tabs-nav-right-btn">
                      <button
                          @click="updateSettings(tab, settings)"
                          v-if="
                          tab !== '/settings/users' &&
                          tab !== '/settings/my-account' &&
                          isStatusActive
                        "
                          class="btn btn-primary w-min-sm waves-effect waves-light ml-1 mt-1 btn-save-hover"
                          style="position: relative; bottom: 10px"
                      >
                        Save
                      </button>
                      <a
                          v-if="tab === '/settings/users' && isStatusActive"
                          href="#"
                          @click.prevent="addNewUser"
                          style="
                          margin-bottom: 5px !important;
                          margin-top: 5px !important;
                        "
                          class="btn btn-primary w-min-sm waves-effect waves-light ml-1 font-weight-bold my-1 plus-btn-hover"
                      >
                        <i class="ti-plus add-user"></i>
                        New User
                      </a>
                      <a
                          v-if="
                          tab === '/settings/business-profile' &&
                          $storage.get(
                            'views.advancedSettings.business.defaultView'
                          ) === 'locations'
                        "
                          href="#"
                          @click.prevent="onClickAddLocation"
                          class="btn btn-primary w-min-sm waves-effect waves-light ml-1 font-weight-bold"
                      >
                        <i class="ti-plus add-user"></i>
                        Add Location
                      </a>
                    </div>
                  </div>
                </div>
                <div class="card-block tab-content row no-gutter">
                  <template
                      v-if="isShopManagerUser && Object.values(settings).length > 0">
                    <div
                        v-if="isTabActive('integrations')"
                        style="width: 100%"
                        id="integrations"
                        class="tab-pane col-lg-6 col-md-6"
                        v-bind:class="{ active: isTabActive('integrations') }"
                        role="tabpanel"
                    >
                      <integrations
                          ref="integrations"
                          v-model="settings"
                      ></integrations>
                    </div>
                    <div
                        style="padding-left: 15px"
                        id="methodology"
                        class="tab-pane col-lg-6 col-md-6"
                        v-bind:class="{ active: isTabActive('methodology') }"
                        role="tabpanel"
                    ></div>
                    <the-estimates
                        v-if="isTabActive('estimates') && settings.estimates && settings.rates"
                        v-model="settings"
                    ></the-estimates>
                    <the-cards
                        v-if="isTabActive('files')"
                        ref="cardsTab"
                        v-model="settings"
                    ></the-cards>

                    <the-invoices
                        v-if="isTabActive('invoices')"
                        v-model="settings"
                    ></the-invoices>

                    <div
                        id="production"
                        class="tab-pane col-lg-12 col-md-12"
                        v-bind:class="{ active: isTabActive('production') }"
                        role="tabpanel"
                    >
                      <production v-model="settings" ref="billing"></production>
                    </div>
                    <div
                        id="estimates-booking"
                        class="tab-pane col-lg-12 col-md-12"
                        v-bind:class="{
                        active: isTabActive('estimates-booking')
                      }"
                        role="tabpanel"
                    >
                      <estimates-booking
                          v-model="settings"
                          ref="billing"
                      ></estimates-booking>
                    </div>
                    <div
                        v-show="isTabActive('users')"
                        style="padding-left: 15px"
                        id="users"
                        class="tab-pane col-lg-12 col-md-12"
                        v-bind:class="{ active: isTabActive('users') }"
                        role="tabpanel"
                    >
                      <users
                          ref="users"
                          :defaultPSLocId="defaultPSLocId"
                          :isActiveParssearchCode="isActiveParssearchCode"
                          :isSetDefaultPSLoc="isSetDefaultPSLoc"
                      ></users>
                    </div>
                    <div
                        v-if="isTabActive('groups')"
                        style="padding-left: 15px"
                        id="groups"
                        class="tab-pane col-lg-12 col-md-12"
                        v-bind:class="{ active: isTabActive('groups') }"
                        role="tabpanel"
                    >
                      <groups ref="groups"></groups>
                    </div>
                    <div
                        v-if="isTabActive('auto-copilot')"
                        style="padding-left: 15px"
                        id="auto-copilot"
                        class="tab-pane col-lg-12 col-md-12"
                        v-bind:class="{ active: isTabActive('auto-copilot') }"
                        role="tabpanel"
                    >
                      <auto-copilot v-model="settings" ref="auto-copilot"></auto-copilot>
                    </div>
                    <div
                        id="sms"
                        class="tab-pane col-lg-12 col-md-12"
                        v-bind:class="{ active: isTabActive('sms') }"
                        role="tabpanel"
                    >
                      <sms v-model="settings" ref="billing"></sms>
                    </div>
                  </template>
                  <div
                      v-if="isTabActive('my-account')"
                      id="my-account"
                      class="tab-pane col-lg-12 col-md-12"
                      v-bind:class="{ active: isTabActive('my-account') }"
                      role="tabpanel"
                  >
                    <my-account
                        ref="myAccount"
                        :defaultPSLocId="defaultPSLocId"
                        :isActiveParssearchCode="isActiveParssearchCode"
                        :isSetDefaultPSLoc="isSetDefaultPSLoc"
                    ></my-account>
                  </div>
                  <template v-if="isShopManagerUser">
                    <div
                        v-if="isTabActive('business-profile')"
                        id="business-profile"
                        class="tab-pane col-lg-12 col-md-12"
                        v-bind:class="{ active: isTabActive('business-profile') }"
                        role="tabpanel"
                    >
                      <div class=" ">
                        <business-profile
                            ref="businessProfile"
                            v-model="settings"
                            :add-location-button-pressed="isAddLocationPressed"
                        ></business-profile>
                      </div>
                    </div>
                  </template>
                  <div
                      v-if="isTabActive('billing')"
                      id="billing"
                      class="tab-pane col-lg-12 col-md-12"
                      v-bind:class="{ active: isTabActive('billing') }"
                      role="tabpanel"
                  >
                    <billing
                        v-model="settings"
                        ref="billing"
                        @reloadVendorSettings="loadVendorSettings"
                    ></billing>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.invoices-editor .ql-editor {
  font-size: 13px;
}

.terms-editor {
  resize: none;
  width: 100%;
  height: 205px;
  border: 1px solid #d1d1d1;
  padding: 15px;
  font-size: 13px;
  line-height: 1.6;
  word-wrap: break-word;
}

.orderNameClass {
  width: auto !important;
}

.setting-card {
  border: none !important;
}

#invoices {
  padding-left: 15px !important;
}

.setting-card > .card-header {
  border-color: red;
  border-bottom: none !important;
  padding-left: 0 !important;
  padding-top: 0 !important;
}

.V3 .setting-card .card .card-header strong {
  font-size: 13px;
  line-height: 18px;
  font-weight: bold;
}

.drag-and-drop {
  cursor: pointer;
}

input[readonly] {
  cursor: unset !important;
}

.trashBarrelClass {
  cursor: pointer;
}

.verticalTextTh {
  vertical-align: middle !important;
}

#users i {
  font-size: 20px;
  margin-left: 10px;
}

#users .ti-write {
  color: #142742;
}

#users .ti-trash {
  color: #d0021b;
}
</style>

<style>
.V3 #cards {
  padding: 0px;
}

.V3 #cards .row > div:first-child {
  padding-right: 15px;
}

.V3 #cards .card-header {
  border-radius: 3px;
}

.V3 #cards .card-block {
  padding: 15px;
}

/**
 * Table
 */
/* table global */
.V3 #cards .table .bx-plus-circle.green {
  color: #34dc6e;
}

.V3 #cards .table .form-control,
.V3 #cards .table select.form-control {
  padding-left: 9.5px;
  padding-right: 9.5px;
}

.V3 #cards .table select.form-control {
  padding-right: 25px !important;
}

/* end table global */

.V3 #cards .table.tab-special td {
  width: auto;
  margin-bottom: 20px;
  padding-top: 15px;
  padding-bottom: 9.75px;
}

.V3 #cards .table.tab-special tr {
  position: relative;
}

.V3 #cards .table .thead-light {
  background-color: rgba(27, 30, 56, 0.12);
}

/* column width */
.V3 #cards .table .twidth-order {
  width: 5%;
  min-width: 100px;
}

.V3 #cards .table .twidth-name {
  width: 20%;
  min-width: 150px;

  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
}

.V3 #cards .table .twidth-auto {
  width: 5%;
  min-width: 100px;
}

.V3 #cards .table .twidth-trigger {
  width: auto;
}

.V3 #cards .table .twidth-action {
  min-width: 75px;
  width: 10%;
}

/* font style */
.V3 #cards .table .tfont-13-bold {
  font-size: 13px;
  line-height: 18px;
  font-weight: 700;
  letter-spacing: normal;
}

.V3 #cards .table .tfont-12-reguler {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  letter-spacing: normal;
}

.V3 #cards .table .tfont-12-bold {
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: normal;
}

.V3 #cards .table .trigger-link {
  color: #1c1f39;
}

/* table icons */
.V3 #cards .table .bx {
  font-size: 20px;
  vertical-align: middle;
  position: relative;
  bottom: 2px;
  transition: transform 250ms ease-out;
}

.V3 #cards .table .active .bx-chevron-down {
  transform: rotate(180deg);
}

.V3 #cards .table .actions {
  display: flex;
  justify-content: flex-end;
}

.V3 #cards .table .actions span {
  margin-left: 15px;
}

.V3 #cards .table .actions > *:hover {
  cursor: pointer;
}

.V3 #cards .table .actions .bx-trash {
  color: #ff5e5e;
}

.V3 #cards .table .actions .bx-plus-circle {
  color: #34dc6e;
}

/* is-edit */
.V3 #cards .table .is-edit .actions .bx-pencil {
  color: #5e79ff;
}

/* animation */
.slide-row-enter-active {
  transition: all 250ms ease-out;
}

.slide-row-leave-active {
  transition: all 200ms ease-in;
}

.slide-row-enter,
.slide-row-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}

/* Input Status */
.V3 #cards .setings-cards-btn-group {
  display: flex;
}

.V3 #cards .add-status-input-settings {
  vertical-align: middle;
}

.V3 #cards .add-status-button {
  flex: 0 1 83px;
  margin-left: 10px;
  border-radius: 3px;
  border-color: #5e79ff;
  box-sizing: border-box;
  color: white;
  background-color: #5e79ff;
  padding: 10px;
  font-size: 12px;
  line-height: 1em;
  font-weight: 700;
  height: 31px;
}

.V3 #cards .add-status-button:focus {
  /* box-shadow: 0 0px 10px #5E79FF; */
  border-color: #1e2f85;
}

/* status detail */
.V3 #cards .trigger {
  display: flex;
  flex-flow: column nowrap;
}

.V3 #cards .trigger__line {
  display: flex;
  align-items: center;
  margin-bottom: 9px;
}

.V3 #cards .trigger__line .cell {
  min-width: 8px;
  margin: 0 10px;
}

.V3 #cards .trigger__line .cell:first-child {
  margin-left: 0px;
}

.V3 #cards .trigger__option {
  flex: 0 0 101px;
}

.V3 #cards .trigger__actions > * {
  margin-left: 9.5px;
}

.V3 .add-user {
  font-weight: bold !important;
}

/* card */
.V3 .card {
  margin-bottom: 0px;
}

.V3 .card-block {
  padding: 15px;
}

/* this probably can be converted to more general .tab-pane */
.tab-pane--estimates,
.tab-pane--invoices {
  max-width: 1157px;
}

@media screen and (max-width: 768px) {
  .V3 #cards .row > div:first-child {
    padding-right: 0px;
  }
}

.pin-image {
  padding-left: 35px !important;
}

@media screen and (max-width: 991px) {
  .pin-image {
    margin-bottom: 15px;
  }
}

/* Create the checkmark/indicator (hidden when not checked) */
.pin-checkmark i {
  font-size: 26px;
  color: white !important;
  margin-left: -2px !important;
  margin-top: -2px !important;
}

.V3 .setting-card .ql-toolbar {
  display: none;
}

.V3 .setting-card .ql-toolbar.ql-snow + .ql-container.ql-snow {
  border: 1px solid rgba(28, 31, 57, 0.25);
}
</style>
<style scoped>
.V3 .setting-card >>> .btn.btn-primary.btn-save-hover {
  transition: none;
  background: linear-gradient(
      135deg,
      rgb(114, 103, 231) 0%,
      rgb(98, 89, 239) 49.12%,
      rgb(78, 69, 238) 100%
  );
}

.V3 .setting-card >>> .btn.btn-primary.btn-save-hover:hover {
  background: #5e78ff;
}
</style>
